import React from 'react';

const JS_Promises = () => {
  return (
    <div >
      <h1>JS_Promises</h1>
      <p>Placeholder component for: "JS Promises"</p>
    </div>
  );
};

export default JS_Promises;
